const headCells = [
    {
        id: 'quantity',
        numeric: false,
        disablePadding: false,
        label: 'Quantity',
        sortable: false
    },
    {
        id: 'image',
        numeric: true,
        disablePadding: false,
        label: 'Image',
        sortable: false
    },
    {
        id: 'catalog',
        numeric: false,
        disablePadding: true,
        label: 'CatalogNo',
    },
    {
        id: 'description',
        numeric: true,
        disablePadding: false,
        label: 'Description',
    },
    {
        id: 'datasheet',
        numeric: false,
        disablePadding: true,
        label: 'DataSheet URL',
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    }
];


export {
    headCells
}